import { render, staticRenderFns } from "./WorkspaceLayer.vue?vue&type=template&id=26fa8840&"
import script from "./WorkspaceLayer.vue?vue&type=script&lang=js&"
export * from "./WorkspaceLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports